import Icon from 'components/UI/Icon';
import { push } from 'connected-react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { getFormattedStreetAddress } from 'utilities/address';
import { getDateAsText } from 'utilities/date';
import './DeliveryOptionsButton.scss';
const warning = require('img/warning.svg');
const calendarIcon = require('theme/icons/calendar.svg');
function DeliveryOptionsButton({ hasAddress, location, date, unsupportedAddress, }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    return (React.createElement("div", { className: "delivery-options-button", onClick: () => {
            dispatch(push('/delivery'));
        }, onKeyDown: (e) => {
            e.key === 'Enter' && dispatch(push('/delivery'));
        }, tabIndex: 0 },
        unsupportedAddress ? (React.createElement(Icon, { className: "delivery-options-button__warning", svg: warning, size: 'medium' })) : (React.createElement(Icon, { className: "delivery-options-button__icon", svg: calendarIcon, size: 'medium' })),
        React.createElement("div", null,
            !hasAddress && (React.createElement("h2", { className: "delivery-options-button__heading" }, t('placeAndTime'))),
            React.createElement("p", { className: "delivery-options-button__text", dangerouslySetInnerHTML: {
                    __html: `${location}${date ? ` ${date}` : `, ${t('chooseDate').toLowerCase()}`}`,
                } }))));
}
function mapStateToProps({ address, region, checkout, distribution, }) {
    var _a;
    return {
        hasAddress: !!((_a = address.active) === null || _a === void 0 ? void 0 : _a.streetName),
        location: getFormattedStreetAddress(address.active) || region.name,
        date: getDateAsText(checkout.deliveryDate, true, true, true),
        unsupportedAddress: !distribution.canDeliver,
    };
}
export default connect(mapStateToProps)(DeliveryOptionsButton);
